import { FormsService } from "../../../services/forms/forms.service";
import { put } from "@redux-saga/core/effects";

import { ChangeValidationMessageRequestActionType } from "../types";
import { changeValidationMessageSuccess } from "../actionCreators";
import { CreateFormResponse } from "../../../services/forms";
import { getChangedValidationMessageValues } from "../../../helpers/dataManipulations";

export function* changeValidationMessage({ payload }: ChangeValidationMessageRequestActionType) {
    try {
        const {
            data: { data: response },
        }: CreateFormResponse = yield FormsService.updateFormComponent({
            data: getChangedValidationMessageValues(payload),
        });
        yield put(changeValidationMessageSuccess({ config: response.config }));
    } catch (error) {
        // yield put(Handle Error);
    }
}
